// deviceStore.ts
import { create } from "zustand";

type State = {
    showPochenLogo: boolean;
};

export const useLogoChangeStore = create<State>()(
        (set) => ({
            showPochenLogo: false,
            setShowPochenLogo: (d:boolean) => set({ showPochenLogo: d }),
        }),

);